/** @format */

import React from "react";
import { Typography, Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TextDecrypt } from "./TextDecrypt";
// import Resume from "../../settings/resume.json";
// import { FirstName, LastName } from "../../utils/getName";
// import url from "./../../settings/settings.json";
// import { useState } from "react";
// import axios from "axios";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAboutMe } from "../../action/notesActions";
import { toast } from "wc-toast";

const useStyles = makeStyles((theme) => ({
  main: {
    maxWidth: "100vw",
    marginTop: "auto",
    marginBottom: "auto",
  },
  heading: {
    marginLeft: theme.spacing(50),
    "@media (max-width: 768px)": {
      marginLeft: theme.spacing(10),
    },
  },
  jobs: {
    "@media (max-width: 768px)": {
      fontSize: "3rem",
    },
  },
}));

export const Content = () => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const AboutMe = useSelector((state) => state.getAboutMe);
  const { loading, aboutMe } = AboutMe;

  // const names = Resume.basics.name.split(" ");

  useEffect(() => {
    // get();
    dispatch(getAboutMe());
  }, [dispatch]);

  if (loading) {
    toast.loading("Loading . . .", { duration: 4000 });
  }
  console.log(aboutMe);

  // for names
  const names = aboutMe ? aboutMe?.fullName?.split(" ") : ["error", "error"];

  const FirstName = names ? names[0] : "";

  const LastName = names ? names[names.length - 1] : "";

  // const Initials = FirstName.charAt(0)
  //   .toUpperCase()
  //   .concat(LastName.charAt(0).toUpperCase());
  // /// for headers
  const MiniHeaader = aboutMe
    ? aboutMe?.MiniHeader?.split(" ")
    : ["error", "error"];

  const Header = aboutMe ? aboutMe?.Header?.split(" ") : ["error", "error"];
  console.log({ Header, MiniHeaader });

  return (
    <Container component="main" className={classes.main} maxWidth="md">
      <div className={classes.heading}>
        <Typography variant="h5" component="h2">
          <TextDecrypt text={`${FirstName} ${LastName}`} />
        </Typography>
        <Typography variant="h1" component="h1" className={classes.jobs}>
          {/* <TextDecrypt text={`${Resume.basics.job1} + `} />
          <TextDecrypt text={`${Resume.basics.job2}`} /> */}
          {Header?.map((item) => (
            <TextDecrypt text={`${item} `} />
          ))}
        </Typography>
        {/* <Typography variant="h5" component="h2"></Typography> */}
        <div
          style={{
            display: "flex",
            gap: "4px",
            flexFlow: "wrap",
            margin: " 0 0 -142px 0",
          }}
        >
          {MiniHeaader?.map((item) => (
            <TextDecrypt text={`${item} `} />
          ))}
        </div>

        {/* <div>sd</div>
        {Heaader?.map((item) => (
          <TextDecrypt text={`${item}`} />
        ))} */}
      </div>
    </Container>
  );
};
